import { Loading } from "@mnk/frontend/components/Loading";
import { ItemList } from "@mnk/frontend/components/domain/items/List";
import { trpc } from "@mnk/frontend/lib/trpc";
import { NotFound } from "@mnk/frontend/pages/NotFound";
import type { GetItem } from "@mnk/shared/models/item";
import type { Office } from "@mnk/shared/models/office";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

export const FolderDetail = () => {
  const [items, setItems] = useState<GetItem[]>([]);
  const [pathItems, setPathItems] = useState<GetItem[]>([]);
  const [office, setOffice] = useState<Office | null>(null);
  const { id } = useParams();

  const getItem = trpc.getItem.useQuery({ id: id ?? "" });
  const item = getItem.data;

  const getItems = trpc.getFolderItems.useQuery({ folderId: item?.id ?? "" }, { enabled: !!item });
  const getPathItems = trpc.getPathItems.useQuery({ path: item?.path ?? "" }, { enabled: !!item });
  const getOffice = trpc.getOffice.useQuery({ id: item?.officeId ?? "" }, { enabled: !!item });

  const afterCreateItem = () => {
    getItems.refetch();
  };

  const mutateItems = async () => {
    await Promise.all([getItems.refetch(), getPathItems.refetch()]);
  };

  useEffect(() => {
    if (getItems.data) {
      setItems(getItems.data);
    }
  }, [getItems.data]);

  useEffect(() => {
    if (getPathItems.data) {
      setPathItems(getPathItems.data);
    }
  }, [getPathItems.data]);

  useEffect(() => {
    if (getOffice.data) {
      setOffice(getOffice.data);
    }
  }, [getOffice.data]);

  if (getItem.isLoading) return <Loading />;
  if (!item || !office) return <NotFound />;

  return (
    <ItemList
      items={items}
      pathItems={pathItems}
      office={office}
      parentId={item.id}
      afterCreateItem={afterCreateItem}
      mutateItems={mutateItems}
    />
  );
};
